package br.com.texeratx.boardgametimeapp.domain.usecases.login

import br.com.texeratx.boardgametimeapp.core.session.SessionManager
import br.com.texeratx.boardgametimeapp.data.model.login.UserSession
import br.com.texeratx.boardgametimeapp.data.repository.LoginRepository

class LoginUseCase(
    private val repository: LoginRepository,
    private val sessionManager: SessionManager
) {
    suspend operator fun invoke(email: String, password: String): Result<Unit> {
        return try {
            val response = repository.login(email, password)

            val session = UserSession(
                token = response.token,
                userId = response.userId,
                email = response.email,
                displayName = response.displayName,
                userImageUrl = response.imageUrl
            )

            sessionManager.save(session)

            Result.success(Unit)

        } catch (e: Exception) {
            Result.failure(e)
        }
    }
}
